import React, { useState } from 'react';
import Navbar from './Navbar';
import { Box, Stack, Typography, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RightSide from './RightSide';
import logo from '../assets/logo.png';
import { useForm, Controller } from 'react-hook-form';
import CustomOtpInput from './CustomOtpInput'; // Import the custom OTP input component
import { useNavigate } from 'react-router-dom';

export default function Otp() {
    const navigate = useNavigate();
    const { control, handleSubmit, formState: { errors } } = useForm({
        defaultValues: { otp: '' },
    });

    const [error, setError] = useState('');

    const onSubmit = (data) => {
        if (!data.otp || data.otp.length !== 6) {
            setError('يرجى إدخال رمز التحقق المؤلف من 6 أرقام');
            return;
        }
        navigate("/");
    };

    return (
        <>
            <Navbar />
            <Stack 
                direction={{ xs: "column", md: "row" }} 
                sx={{ minHeight: '100vh', borderLeft: { md: '30px solid #15513c' } }}
            >
                {/* Left Side - OTP Form */}
                <Stack
                    alignItems="center"
                    justifyContent="center"
                    sx={{ 
                        flexBasis: { md: "50%" }, 
                        width: { xs: "100%", md: "50%" }, 
                        p: { xs: 3, md: 5 } 
                    }}
                >
                    <Stack sx={{ width: "100%", maxWidth: "400px" }} spacing={3}>
                        {/* Logo */}
                        <Box sx={{ textAlign: 'center' }}>
                            <img src={logo} alt="Logo" width="60px" />
                        </Box>

                        {/* Welcome Text */}
                        <Box textAlign="center">
                            <Typography variant={{ xs: "body1", sm: "h6" }} fontWeight="bold">
                                خطوة أخيرة لإكمال تسجيلك في منصة نبني
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                أدخل رمز التحقق المرسل إلى ايميلك لإتمام عملية التسجيل والوصول إلى حسابك الشخصي
                            </Typography>
                        </Box>

                        {/* OTP Form */}
                        <Box
                            component="form"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: "100%"
                            }}
                            onSubmit={handleSubmit(onSubmit)}
                        >
                            <Controller
                                control={control}
                                name="otp"
                                rules={{
                                    required: 'رمز التحقق مطلوب',
                                    minLength: { value: 6, message: 'رمز التحقق يجب أن يكون 6 أرقام' },
                                }}
                                render={({ field }) => (
                                    <CustomOtpInput
                                        value={field.value}
                                        onChange={field.onChange}
                                        length={6} 
                                    />
                                )}
                            />
                            {errors.otp && (
                                <Typography variant="body2" color="error" textAlign="center">
                                    {errors.otp.message}
                                </Typography>
                            )}
                            {error && (
                                <Typography variant="body2" color="error" textAlign="center">
                                    {error}
                                </Typography>
                            )}
                            <Typography 
                                variant="body2" 
                                textAlign="center" 
                                color="textSecondary"
                                sx={{ px: 2 }}
                            >
                                لقد أرسلنا رمز التحقق عبر
                                <span style={{ padding: '0 2px' }}>الايميل</span>
                                إلى ايميلك  المسجل.  
                                <br />
                                الرجاء إدخال الرمز المكون من 6 أرقام لإكمال تسجيل حسابك.
                            </Typography>

                            <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                    backgroundColor: '#15513c',
                                    color: '#fff',
                                    borderRadius: '6px',
                                    py: 1.5,
                                    mt: 2,
                                }}
                                type="submit"
                            >
                                <ArrowBackIcon sx={{ ml: 1 }} />
                                إتمام التسجيل
                            </Button>
                        </Box>
                    </Stack>
                </Stack>

                {/* Right Side */}
                <RightSide sx={{ flexBasis: "50%", width: { xs: "100%", md: "50%" } }} />
            </Stack>
        </>
    );
}
